import { Base } from '../base-component';
import './image-full-with-text.component.scss';

export class ImageFullWithText extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/image-full-with-text/image-full-with-text.component.ts